import React, { useEffect, useState } from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { IMAGES, MOCK_EVENTS } from '../mock/mock';
import { getEvents } from '../lib/api';
import Reveal from '../components/Reveal';

const CATS = ['All', 'Worship', 'Community', 'Kids', 'Men', 'Women'];

const formatDate = (iso) => {
  const d = new Date(iso + 'T00:00:00');
  return {
    month: d.toLocaleString('en-US', { month: 'short' }),
    day: d.getDate(),
    weekday: d.toLocaleString('en-US', { weekday: 'long' }),
    full: d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
  };
};

const Events = () => {
  const [events, setEvents] = useState(MOCK_EVENTS);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    getEvents().then((d) => { if (Array.isArray(d) && d.length) setEvents(d); }).catch(() => {});
  }, []);

  const filtered = filter === 'All' ? events : events.filter((e) => e.category === filter);

  return (
    <div>
      <section className="relative h-[52vh] min-h-[420px] flex items-center justify-center overflow-hidden">
        <img src={IMAGES.fellowship} alt="Events" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b2027]/80 via-[#0b2027]/55 to-[#0b2027]/85" />
        <div className="relative text-center px-6">
          <Reveal>
            <p className="text-[#c9a24b] uppercase tracking-[0.36em] text-xs mb-5">Get Involved</p>
            <h1 className="font-serif-display italic text-white text-5xl md:text-7xl">Events</h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#f6f2ea] py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <p className="text-[#3a4d54] text-lg leading-relaxed">
              We have many opportunities to get and stay involved. Check out what we have going on this month!
            </p>
          </Reveal>

          <Reveal className="flex flex-wrap justify-center gap-3 mb-14">
            {CATS.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-6 py-2.5 text-xs uppercase tracking-[0.18em] border transition-all duration-300 ${filter === c ? 'bg-[#0f2e38] text-white border-[#0f2e38]' : 'bg-transparent text-[#3a4d54] border-[#c9c3b6] hover:border-[#17565f] hover:text-[#17565f]'}`}
              >
                {c}
              </button>
            ))}
          </Reveal>

          <div className="grid md:grid-cols-2 gap-8">
            {filtered.map((ev, i) => {
              const d = formatDate(ev.date);
              return (
                <Reveal key={ev.id} delay={(i % 2) * 120}>
                  <div className="group flex flex-col sm:flex-row bg-white shadow-sm hover:shadow-xl transition-shadow duration-500 overflow-hidden">
                    <div className="relative sm:w-2/5 overflow-hidden">
                      <img src={ev.image} alt={ev.title} className="w-full h-52 sm:h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      <div className="absolute top-4 left-4 bg-[#0f2e38] text-white text-center px-4 py-2">
                        <p className="text-[#c9a24b] text-xs uppercase tracking-widest">{d.month}</p>
                        <p className="font-serif-display text-2xl leading-none">{d.day}</p>
                      </div>
                    </div>
                    <div className="p-7 sm:w-3/5">
                      <span className="text-xs uppercase tracking-[0.2em] text-[#2c8a95]">{ev.category}</span>
                      <h3 className="font-serif-display text-2xl text-[#0f2e38] mt-2 mb-3">{ev.title}</h3>
                      <p className="text-[#5a6b71] text-sm leading-relaxed mb-5 line-clamp-2">{ev.description}</p>
                      <div className="space-y-2 text-sm text-[#3a4d54]">
                        <p className="flex items-center gap-2"><Calendar className="h-4 w-4 text-[#c9a24b]" />{d.weekday}, {d.full}</p>
                        <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#c9a24b]" />{ev.time}</p>
                        <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#c9a24b]" />{ev.location}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
          {filtered.length === 0 && (
            <p className="text-center text-[#5a6b71] py-16">No events in this category right now. Check back soon!</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Events;
